import {RouteConfig} from "vue-router"
import {PRIV} from "@/router/rights"

const routes: Array<RouteConfig> = [
  {
    path: "/motivation",
    name: "motivation",
    component: () => import("@/views/Motivation/Motivation.vue"),
    meta: {
      requiresAuth: true,
      flags: [PRIV.acc_motivation],
      layout: "home",
      title: "Мотивация",
    },
  },
  {
    path: "/motivation/bonuses",
    name: "motivation-bonuses",
    component: () => import("@/views/Motivation/Bonuses.vue"),
    meta: {
      requiresAuth: true,
      flags: [PRIV.acc_motivation],
      layout: "home",
      title: "Мои бонусы",
    },
  },
  {
    path: "/motivation/admin",
    name: "motivation-admin",
    component: () => import("@/views/MotivationAdmin/MotivationAdmin.vue"),
    meta: {
      requiresAuth: true,
      flags: [PRIV.acc_motivation],
      layout: "home",
      title: "Мотивация — админка",
    },
  },
]

export default routes
